import { Business } from '../../models/business';
import clsx from 'clsx';
import { buildUrlsFromUploadedFile } from '../Inputs/InputFile/oneFile/helpers';
import StarRatings from 'react-star-ratings';
import { useMemo } from 'react';
import SubjectMini from '../SubjectMini/SubjectMini';
import s from './BusinessCard.module.scss';
import { useContext } from 'react';
import { NavContext, useIonRouter } from '@ionic/react';
import ButtonLabel from '../Buttons/ButtonLabel/ButtonLabel';
import { chevronForwardOutline } from 'ionicons/icons';
import {
  AnalyticEventsEnum,
  getBusinessAnalyticData,
  trackEvent,
} from '../../Analytics';
import { getSeoApproximateLocation } from '../Location/config';

import sg from '../../styles/global.module.scss';

export interface BusinessCardProps {
  business: Business;
  description?: string | null;
  rating?: number;
  reviewsCount?: number;
  softDisabled?: boolean;
}

export const getBusinessDetailUrl = (business: Business) => {
  return `/catalog/${getSeoApproximateLocation(business.location)}/company/${
    business.id
  }`;
};

const BusinessCard: React.FC<BusinessCardProps> = ({
  business,
  description,
  rating,
  reviewsCount,
  softDisabled,
}) => {
  const navContext = useContext(NavContext);

  const refferedByCompanyPage =
    navContext.routeInfo?.pushedByRoute?.includes('/company/');

  const avatarUrls = useMemo(() => {
    return buildUrlsFromUploadedFile(business.uploadedFiles[0]);
  }, [business.uploadedFiles]);

  const router = useIonRouter();

  return (
    <SubjectMini
      suffixIcon={
        !softDisabled ? (
          <ButtonLabel
            label="DETAILS"
            skipBorder
            iconSrc={chevronForwardOutline}
          />
        ) : null
      }
      softDisabled={softDisabled}
      title={business.name}
      description={
        rating ? (
          <div className={clsx(sg.Stack_Horizontal, sg.Gap_10)}>
            <StarRatings
              rating={rating}
              starRatedColor="var(--color-main)"
              starEmptyColor="var(--color-main-low)"
              starDimension="20px"
              starSpacing="1px"
            />
            <p className={clsx(s.Text__review)}>
              {rating ? reviewsCount : 0} reviews
            </p>
          </div>
        ) : (
          description
        )
      }
      image={avatarUrls.content.low}
      isActive={true}
      onClick={async e => {
        if (refferedByCompanyPage) {
          navContext.goBack();
          e.preventDefault();
        } else {
          router.push(getBusinessDetailUrl(business), 'forward', 'push');
        }

        const analyticData = getBusinessAnalyticData(business);
        await trackEvent(AnalyticEventsEnum.CLICK__BUSINESS, {
          ...analyticData,
        });
      }}
    />
  );
};

export default BusinessCard;
